import React, { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { InputErrorIcon } from 'shared/icon';

interface IProp {
	name: string;
	title: string;
	errorMsg: string;
	placeholder: string;
	required?: boolean;
	rows?: number;
	cols?: number;
	register: UseFormRegister<any>;
	value?: any;
	onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	readOnly?: boolean;
}

export const Textarea: FC<IProp> = ({
	name,
	title,
	errorMsg,
	placeholder,
	required,
	register,
	rows,
	cols,
	value,
	onChange,
	readOnly
}) => {
	const { onChange: rhfOnChange, ...restRegister } = register(name);
	return (
		<div className='min-h-[84px]'>
			<label htmlFor={name} className='input-label'>
				{title} {required && <sub className='bottom-[-7px]'>*</sub>}
			</label>
			<div className='relative'>
				<textarea
					rows={rows}
					cols={cols}
					value={value}
					id={name}
					className={`flex w-full rounded-lg border resize-none ${
						errorMsg ? 'border-red-600' : 'border-themeGray'
					} p-2.5 text-sm`}
					placeholder={placeholder}
					onChange={(e) => {
						onChange && onChange(e);
						rhfOnChange && rhfOnChange(e);
					}}
					readOnly={readOnly}
					{...restRegister}
				/>
				{errorMsg && (
					<div className='pointer-events-none absolute inset-y-0 end-0 flex items-center pe-3'>
						<InputErrorIcon />
					</div>
				)}
			</div>
			{errorMsg && <p className='text-left text-xs text-red-600 first-letter:uppercase'>{errorMsg}</p>}
		</div>
	);
};
